import React from "react";

const getStrokeColor = (percentage) => {
  if (percentage < 80) return "var(--primary-color-text)";
  if (percentage > 80 && percentage <= 100) return "#00bf6f";
  if (percentage > 100) return "#ff4c5e";
  return "#ccc";
};

const CircularProgress = ({ value, size = 40, strokeWidth = 4, required }) => {
  const percentage = required ? Math.round((value / required) * 100) : 0;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.min(percentage, 100);
  const offset = circumference - (progress / 100) * circumference;
  const strokeColor = getStrokeColor(percentage);

  return (
    <svg width={size} height={size}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#eee"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 0.5s" }}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy=".3em"
        style={{
          fontSize: "10px", // smaller text inside
          fontWeight: "bold",
          fill: "#333",
        }}
      >
        {percentage}%
      </text>
    </svg>
  );
};

export default CircularProgress;
